import { render, staticRenderFns } from "./AuthEnvelope.vue?vue&type=template&id=1c96c99a&"
import script from "./AuthEnvelope.vue?vue&type=script&lang=js&"
export * from "./AuthEnvelope.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports